import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../pages/remittance-beta/state/authSlice";
import remittanceReducer from "../pages/remittance-beta/state/remittanceSlice";

const authPersistConfig = {
  key: "auth_state",
  storage
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  remittance: remittanceReducer
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;